import React from 'react';
import { GALLERY_ALBUMS } from '../../constants';
import { Reveal, TextReveal } from '../../components/Reveal';
import { AlbumGallery } from './AlbumGallery';

export const AboutSection = () => {
  return (
    <section id="about" className="pf-section pf-about-section">
      <div className="pf-container">
        <div className="pf-section-heading">
          <Reveal as="span" className="pf-section-index" distance={6}>02 / About</Reveal>
          <TextReveal delay={0.08}>A little <em>about me</em></TextReveal>
        </div>
        <div className="pf-about-layout">
          <Reveal as="p" className="pf-about-lead">
            I like making complex things feel simple — from the first screen to the last line of backend code.
          </Reveal>
          <div className="pf-about-side">
            <Reveal as="p" delay={0.12}>I'm a Computer Science student at the University of Cebu, focused on full stack development. I work across mobile, web, and backend systems, with a sharp eye for usable interfaces and maintainable code.</Reveal>
            <div className="pf-about-facts">
              {['Based in Cebu, Philippines', 'Computer Science / University of Cebu', 'Mobile + full stack development'].map((fact, index) => (
                <Reveal as="span" key={fact} distance={10} delay={index * 0.08}>{fact}</Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="pf-container pf-about-gallery">
        <div className="pf-gallery-heading">
          <Reveal as="span" className="pf-section-index" distance={10}>Life beyond the code</Reveal>
        </div>
      </div>
      <AlbumGallery albums={GALLERY_ALBUMS} />
    </section>
  );
};
